import useTranslation from 'hooks/useTranslation'
import React from 'react'
import './style.scss'

interface SocialBtnProps {
  type: 'apple' | 'google'
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

const SocialBtn: React.FC<SocialBtnProps> = ({ type, onClick }) => {
  const { t } = useTranslation('basic')
  switch (type) {
    case 'apple': return (
      <button
        className='button--social'
        onClick={onClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none">
          <path d="M13.498 9.667a3.86 3.86 0 0 1 1.838-3.238 3.951 3.951 0 0 0-3.113-1.683c-1.31-.138-2.58.784-3.247.784-.68 0-1.708-.77-2.814-.748A4.146 4.146 0 0 0 2.673 6.91c-1.508 2.611-.383 6.45 1.062 8.56.723 1.034 1.567 2.189 2.673 2.148 1.082-.045 1.486-.69 2.792-.69 1.293 0 1.672.69 2.8.664 1.161-.02 1.893-1.039 2.59-2.082a8.55 8.55 0 0 0 1.184-2.412 3.73 3.73 0 0 1-2.276-3.431ZM11.367 3.358a3.8 3.8 0 0 0 .87-2.723A3.866 3.866 0 0 0 9.734 1.93a3.616 3.616 0 0 0-.892 2.621c.98.01 1.91-.43 2.524-1.193Z" fill="var(--theme-text)" />
        </svg>
        <span>{t('continueWithApple')}</span>
      </button>
    )

    case 'google': return (
      <button
        className='button--social'
        onClick={onClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <path fill="#4285f4" fill-opacity="1" fill-rule="evenodd" stroke="none" d="M17.64 9.2q-.002-.956-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"></path>
          <path fill="#34a853" fill-opacity="1" fill-rule="evenodd" stroke="none" d="M9.003 18c2.43 0 4.467-.806 5.956-2.18l-2.909-2.26c-.806.54-1.836.86-3.047.86-2.344 0-4.328-1.584-5.036-3.711H.96v2.332C2.44 15.983 5.485 18 9.003 18"></path>
          <path fill="#fbbc05" fill-opacity="1" fill-rule="evenodd" stroke="none" d="M3.964 10.712c-.18-.54-.282-1.117-.282-1.71 0-.593.102-1.17.282-1.71V4.96H.957C.347 6.175 0 7.55 0 9.002c0 1.452.348 2.827.957 4.042z"></path>
          <path fill="#ea4335" fill-opacity="1" fill-rule="evenodd" stroke="none" d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.464.891 11.428 0 9.002 0 5.485 0 2.44 2.017.96 4.958L3.967 7.29c.708-2.127 2.692-3.71 5.036-3.71"></path>
        </svg>
        <span>{t('continueWithGoogle')}</span>
      </button>
    )
  }
}

export default SocialBtn